<template>
  <div class="promo-panel" :class="{ 'promo-panel--stack': layout === 'stack' }">
    <div v-if="showGlow" class="promo-glow"></div>

    <div class="promo-head">
      <div class="gift-icon">
        <i class="bi bi-gift-fill"></i>
      </div>
      <h2 class="promo-title">{{ title }}</h2>
      <p class="promo-subtitle">
        注册即送 <strong>{{ registerCopy.charLabel }}</strong> 免费改写额度，不用充值也能先跑通一轮降重/降 AI
      </p>
    </div>

    <div class="reward-grid">
      <div class="reward-card primary">
        <span class="reward-label">微信注册即送</span>
        <div class="reward-value">
          <strong>{{ registerCopy.charLabel }}</strong>
        </div>
        <p class="reward-equiv">≈ {{ registerCopy.pointsLabel }} · 1 点 = 1 字</p>
        <p>{{ registerCopy.usageHint }}</p>
      </div>
      <div class="reward-card secondary">
        <span class="reward-label">每邀请 1 位好友</span>
        <div class="reward-value">
          <strong>+{{ inviteCopy.charLabel }}</strong>
        </div>
        <p class="reward-equiv">≈ {{ inviteCopy.pointsLabel }} · 多邀多得</p>
        <p>{{ inviteCopy.usageHint }}</p>
      </div>
    </div>

    <ul class="tips-list">
      <li><i class="bi bi-check-circle-fill"></i>1 点按 1 字扣减，798 字只扣 798 点，不凑整</li>
      <li><i class="bi bi-check-circle-fill"></i>支持知网、维普、万方等主流检测平台</li>
      <li><i class="bi bi-check-circle-fill"></i>体验额度永久有效，登录后自动到账</li>
    </ul>
  </div>
</template>

<script>
import {
  describeInviterReward,
  describeNewMemberReward
} from '@/utils/rewardCopy'

export default {
  name: 'InviteRewardPromoPanel',
  props: {
    newMemberReward: { type: Number, default: 2000 },
    inviterReward: { type: Number, default: 1000 },
    title: { type: String, default: '新用户福利 · 邀请有奖' },
    layout: {
      type: String,
      default: 'grid',
      validator: val => ['grid', 'stack'].includes(val)
    },
    showGlow: { type: Boolean, default: true }
  },
  computed: {
    registerCopy() {
      return describeNewMemberReward(this.newMemberReward)
    },
    inviteCopy() {
      return describeInviterReward(this.inviterReward)
    }
  }
}
</script>

<style scoped>
.promo-panel {
  position: relative;
  height: 100%;
  padding: 32px 28px;
  background: linear-gradient(165deg, #ffffff 0%, #f3f8ff 55%, #f3f0ff 100%);
  overflow: hidden;
}

.promo-glow {
  position: absolute;
  top: -80px;
  right: -60px;
  width: 220px;
  height: 220px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(25, 118, 210, 0.35), transparent 70%);
  pointer-events: none;
}

.promo-head {
  position: relative;
  text-align: center;
  margin-bottom: 22px;
}

.gift-icon {
  width: 56px;
  height: 56px;
  margin: 0 auto 12px;
  border-radius: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #1976d2, #42a5f5);
  color: #fff;
  font-size: 24px;
  box-shadow: 0 12px 24px rgba(25, 118, 210, 0.35);
}

.promo-title {
  margin: 0 0 8px;
  font-size: 22px;
  font-weight: 700;
  color: #111827;
}

.promo-subtitle {
  margin: 0;
  font-size: 13px;
  line-height: 1.6;
  color: #6b7280;
}

.promo-subtitle strong {
  color: #1976d2;
  font-weight: 700;
}

.reward-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin-bottom: 18px;
}

.promo-panel--stack .reward-grid {
  grid-template-columns: 1fr;
}

.reward-card {
  padding: 14px 12px;
  border-radius: 14px;
  border: 1px solid transparent;
}

.reward-card.primary {
  background: linear-gradient(145deg, #e3f2fd, #fff);
  border-color: #90caf9;
}

.reward-card.secondary {
  background: linear-gradient(145deg, #f0f7ff, #fff);
  border-color: #bbdefb;
}

.reward-label {
  display: block;
  font-size: 12px;
  font-weight: 600;
  color: #1976d2;
  margin-bottom: 8px;
}

.reward-card.secondary .reward-label {
  color: #0288d1;
}

.reward-value {
  display: flex;
  align-items: baseline;
  gap: 4px;
  margin-bottom: 8px;
}

.reward-value strong {
  font-size: 26px;
  line-height: 1;
  color: #111827;
}

.reward-equiv {
  margin: 0 0 8px;
  font-size: 11px;
  line-height: 1.4;
  color: #0288d1;
  font-weight: 500;
}

.reward-card.primary .reward-equiv {
  color: #1976d2;
}

.reward-card p {
  margin: 0;
  font-size: 12px;
  line-height: 1.5;
  color: #6b7280;
}

.tips-list {
  margin: 0;
  padding: 0;
  list-style: none;
}

.tips-list li {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-bottom: 8px;
  font-size: 12px;
  line-height: 1.5;
  color: #4b5563;
}

.tips-list i {
  color: #22c55e;
  margin-top: 2px;
  flex-shrink: 0;
}

@media (max-width: 720px) {
  .promo-panel {
    padding: 24px 20px;
  }

  .reward-grid {
    grid-template-columns: 1fr;
  }
}
</style>
